const GEO_TIMEOUT_MS = 7000;

const normalizeLocation = (payload = {}) => ({
  city: payload.city || payload.town || payload.village || '',
  state: payload.state || payload.region || payload.regionName || '',
  country: payload.country_name || payload.country || '',
});

const getBrowserCoordinates = () => new Promise((resolve, reject) => {
  if (typeof navigator === 'undefined' || !navigator.geolocation) {
    reject(new Error('Geolocation is not supported.'));
    return;
  }

  navigator.geolocation.getCurrentPosition(
    (position) => resolve(position?.coords || null),
    (error) => reject(error),
    { enableHighAccuracy: false, timeout: GEO_TIMEOUT_MS, maximumAge: 10 * 60 * 1000 },
  );
});

const reverseGeocode = async ({ latitude, longitude }) => {
  const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`);
  const data = await response.json().catch(() => ({}));
  return normalizeLocation(data?.address || {});
};

const getIpLocation = async () => {
  const response = await fetch('https://ipapi.co/json/');
  const data = await response.json().catch(() => ({}));
  return normalizeLocation(data);
};

export const resolveHomepageLocation = async () => {
  try {
    const coords = await getBrowserCoordinates();
    if (coords?.latitude && coords?.longitude) {
      const geocoded = await reverseGeocode({ latitude: coords.latitude, longitude: coords.longitude });
      if (geocoded.city || geocoded.state || geocoded.country) {
        return { ...geocoded, latitude: coords.latitude, longitude: coords.longitude, source: 'geolocation' };
      }
      return { city: '', state: '', country: '', latitude: coords.latitude, longitude: coords.longitude, source: 'geolocation' };
    }
  } catch (_error) {
    // fall through to IP lookup
  }

  try {
    const ipLocation = await getIpLocation();
    if (ipLocation.city || ipLocation.state || ipLocation.country) {
      return { ...ipLocation, latitude: null, longitude: null, source: 'ip' };
    }
  } catch (_error) {
    // ignore
  }

  if (typeof navigator !== 'undefined') {
    const locale = navigator.language || 'en-US';
    const country = locale.split('-')[1] || '';
    return { city: '', state: '', country, latitude: null, longitude: null, source: 'country' };
  }

  return { city: '', state: '', country: '', latitude: null, longitude: null, source: 'country' };
};
